import { Injectable } from '@angular/core';

import { createEffect, Actions, ofType } from '@ngrx/effects';
import { iif, of } from 'rxjs';
import { switchMap, withLatestFrom, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { EntitiesListService } from '@apps/auth/domain/entities-list.service';
import { Entity } from '@apps/auth/domain/models/back/entity';
import { IAuroraState } from '@apps/aurora.state';
import { NotificationService } from '@common/services';

import * as fromBackAuthStoreActions from './entities-internal.actions';
import { getEntitiesInternalIsDataValid, getEntitiesInternalQueryString } from './entities-internal.selectors';

@Injectable()
export class BackAuthEntitiesInternalEffects
{
    constructor (
        private actions: Actions,
        private entitiesListService: EntitiesListService,
        private notificationService: NotificationService,
        private store: Store<IAuroraState>
    )
    { }
    backAuthEntitiesInternalODataRequested = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromBackAuthStoreActions.BackAuthEntitiesInternalODataRequested),
                    withLatestFrom(this.store.select(getEntitiesInternalIsDataValid)),
                    switchMap(([, isDataValid]: [any, boolean]) =>
                        iif(
                            () => isDataValid,
                            of(true),
                            of(false)
                                .pipe(
                                    withLatestFrom(this.store.select(getEntitiesInternalQueryString)),
                                    switchMap(([, qs]: [boolean, string]) =>
                                        this.entitiesListService.getEntities(qs)
                                            .pipe(
                                                tap((entities: Entity[]) =>
                                                    this.store.dispatch(fromBackAuthStoreActions.BackAuthEntitiesInternalODataLoaded({ entities }))
                                                )
                                            )
                                    )
                                )
                        )
                    )
                ),
        { dispatch: false }
    );
}
